import { ReactText } from "react";
import { GetRequestSingleItemInterface } from "interfaces/ActionReducer/GetMethod/GetRequestSingleItem";
import { ResetStateAction } from "components/curb/ManagerAnalyzer/Toggle/commonUtilities";

export const SHOW_WORK_ORDERS_LIST_VIEW = "SHOW_WORK_ORDERS_LIST_VIEW";
export const SET_WORK_ORDERS_PARAMS = "SET_WORK_ORDERS_PARAMS";
export const GET_WORK_ORDERS = "GET_WORK_ORDERS";
export const WORK_ORDERS_RECEIVED = "WORK_ORDERS_RECEIVED";
export const CREATE_WORK_ORDER = "CREATE_WORK_ORDER";
export const SELECTED_WORD_ORDER_IDS = "SELECTED_WORD_ORDER_IDS";
export const UPDATE_WORK_ORDER_STATUS = "UPDATE_WORK_ORDER_STATUS";
export const DELETE_WORK_ORDERS = "DELETE_WORK_ORDERS";
export const TOGGLE_WORK_ORDER_ACTION_PERFORMED = "TOGGLE_WORK_ORDER_ACTION_PERFORMED";
export const GET_WORK_ORDERS_TABLE_FILTERS = "GET_WORK_ORDERS_TABLE_FILTERS";
export const RECEIVED_WORK_ORDERS_TABLE_FILTERS = "RECEIVED_WORK_ORDERS_TABLE_FILTERS";
export const ADD_COMMENT_TO_WORK_ORDER = "ADD_COMMENT_TO_WORK_ORDER";
export const SELECTED_WORK_ORDER_COLUMNS = "SELECTED_WORK_ORDER_COLUMNS";

export interface WorkOrdersParamsInterface {
    [index: string]: string | number | boolean | string[];
}

export interface CreateWorkOrderParamsInterface {
    name: string;
    file: File;
}
export interface ShowWorkOrderListViewAction {
    type: typeof SHOW_WORK_ORDERS_LIST_VIEW;
    payload: { showWorkOrdersListView: boolean };
}

export interface GetWorkOrdersAction {
    payload: { params: Partial<GetRequestSingleItemInterface> };
    type: typeof GET_WORK_ORDERS;
}

export interface SetWorkOrdersParamsAction {
    type: typeof SET_WORK_ORDERS_PARAMS;
    payload: { workOrdersParams: Partial<GetRequestSingleItemInterface> };
}

export interface SelectedWorkOrderColumnsAction {
    type: typeof SELECTED_WORK_ORDER_COLUMNS;
    payload: { selectedColumns: string[] };
}

export interface commentPropType {
    comment: string;
    id: number;
    parent_comment_id: number | null;
    user_id: number;
    username: string;
    work_order_id: number;
    created: string;
    replies: commentPropType[];
    [prop: string]: any;
}

export interface WorkOrdersPropsType {
    created: string;
    status: string;
    id: number;
    user: {
        id: number;
        username: string;
    };
    file: string;
    file_name: string;
    name: string;
    action_on: string;
    comments: commentPropType[];
}

export interface WorkOrdersResponseInterface {
    meta: {
        count: number;
        next: null | string;
        previous: null | string;
    };
    results: WorkOrdersPropsType[];
}

export interface WorkOrdersReceivedAction {
    type: typeof WORK_ORDERS_RECEIVED;
    payload: { workOrdersList: WorkOrdersResponseInterface };
}

export interface CreateWorkOrderAction {
    type: typeof CREATE_WORK_ORDER;
    payload: { params: CreateWorkOrderParamsInterface };
}

export interface UpdateWorkOrderParams {
    status: string;
}

export interface UpdateWorkOrderStatusAction {
    type: typeof UPDATE_WORK_ORDER_STATUS;
    payload: { id: number; params: UpdateWorkOrderParams };
}

export interface SetSelectedWordOrderIdsAction {
    payload: { selectedWorkOrderIDs: number[] };
    type: typeof SELECTED_WORD_ORDER_IDS;
}

export interface ToggleWorkOrderActionPerformedAction {
    type: typeof TOGGLE_WORK_ORDER_ACTION_PERFORMED;
}

export interface DeleteWorkOrdersAction {
    payload: { ids: number[]; afterDelete: () => void };
    type: typeof DELETE_WORK_ORDERS;
}

export interface GetWorkOrdersTableFiltersAction {
    type: typeof GET_WORK_ORDERS_TABLE_FILTERS;
}

export interface ListViewFiltersType {
    column_display_name: string;
    column_filter_name: string;
    is_filtering_enabled: boolean;
    is_sortable: boolean;
    values: {
        label: string;
        value: ReactText;
    }[];
}

export interface ReceivedWorkOrdersTableFiltersAction {
    payload: { data: ListViewFiltersType[] };
    type: typeof RECEIVED_WORK_ORDERS_TABLE_FILTERS;
}

export interface AddCommentToWorkOrderParamsTypes {
    comment: string;
    parent_comment_id: number | string | null;
    work_order_id: string | number;
}

export interface AddCommentToWorkOrderAction {
    payload: { params: AddCommentToWorkOrderParamsTypes };
    type: typeof ADD_COMMENT_TO_WORK_ORDER;
}
export interface WorkOrdersDataStateInterface {
    showWorkOrdersListView: boolean;
    workOrdersParams: Partial<GetRequestSingleItemInterface>;
    workOrdersList: WorkOrdersResponseInterface;
    isFetchingWorkOrders: boolean;
    selectedWorkOrderIDs: number[];
    toggleWorkOrderActionPerformed: boolean;
    workOrdersTableFilters: ListViewFiltersType[];
    selectedColumns: string[];
}

export type WorkOrdersDataTypes =
    | GetWorkOrdersAction
    | SetWorkOrdersParamsAction
    | WorkOrdersReceivedAction
    | CreateWorkOrderAction
    | UpdateWorkOrderStatusAction
    | SetSelectedWordOrderIdsAction
    | ToggleWorkOrderActionPerformedAction
    | DeleteWorkOrdersAction
    | GetWorkOrdersTableFiltersAction
    | ReceivedWorkOrdersTableFiltersAction
    | AddCommentToWorkOrderAction
    | ShowWorkOrderListViewAction
    | ResetStateAction
    | SelectedWorkOrderColumnsAction;
